/** @returns {import("serialport")} */
const serialport = () => window?.nodeModules?.serialport;

export default serialport;
